import React, { useRef } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Simplebar } from '@hivebrite/design-system/Simplebar';

const PanelSimpleBar = ({ children }) => {
  const simpleBarRef = useRef();
  const wrapperRef = useRef();

  return (
    <WrapperSimpleBar ref={wrapperRef}>
      <SimpleBarStyled ref={simpleBarRef} autoHide>
        {children}
      </SimpleBarStyled>
    </WrapperSimpleBar>
  );
};

export default PanelSimpleBar;

const WrapperSimpleBar = styled(Box).attrs(() => ({
  bg: 'white',
  display: 'block',
  flex: 1,
}))`
  position: relative;
`;
const SimpleBarStyled = styled(Simplebar)`
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute !important;
  right: 0;
  top: 0;

  .simplebar-track.simplebar-vertical {
    right: 0;
  }

  .simplebar-content-wrapper {
    overflow-y: scroll !important;
  }
`;
